import { render, staticRenderFns } from "./NossosPlanos.vue?vue&type=template&id=f4db9026"
import script from "./NossosPlanos.vue?vue&type=script&lang=js"
export * from "./NossosPlanos.vue?vue&type=script&lang=js"
import style0 from "./NossosPlanos.vue?vue&type=style&index=0&id=f4db9026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports